import { refresh, sendCode, verifyEmail } from "../auth/asyncThunks";
import {
  generateCollection,
  regenerateCollection,
  toggleToFavorite,
  updateTrainModel,
} from "../model/asyncThunks";
import {
  addDailyCredits,
  deleteAccount,
  fetchUserInfo,
  changeUsername,
  getReferralUsers,
} from "./asyncThunk";

export const fetchUserInfoBuilder = (builder) => {
  builder.addCase(fetchUserInfo.pending, (state) => {
    state.fetchUserInfoPending = true;
  });
  builder.addCase(fetchUserInfo.fulfilled, (state, { payload }) => {
    state.user = payload.user;
    state.fetchUserInfoPending = false;
  });
  builder.addCase(fetchUserInfo.rejected, (state) => {
    state.user = undefined;
    state.fetchUserInfoPending = false;
  });
};

export const sendCodeBuilder = (builder) => {
  builder.addCase(sendCode.fulfilled, (state, { payload }) => {
    const { user } = payload;
    state.user = user;
  });
};

export const verifyEmailBuilder = (builder) => {
  builder.addCase(verifyEmail.fulfilled, (state, { payload }) => {
    const { user } = payload.data;
    state.user = user;
  });
};

export const generateCollectionBuilder = (builder) => {
  builder.addCase(generateCollection.fulfilled, (state, { payload }) => {
    const { credits } = payload.data;
    state.user.credits = credits;
  });
};

export const regenerateCollectionBuilder = (builder) => {
  builder.addCase(regenerateCollection.fulfilled, (state, { payload }) => {
    const { credits } = payload.data;
    state.user.credits = credits;
  });
};

export const addDailyCreditsBuilder = (builder) => {
  builder.addCase(addDailyCredits.pending, (state) => {
    state.addDailyCreditsPending = true;
  });
  builder.addCase(addDailyCredits.fulfilled, (state, { payload }) => {
    const { credits, lastFreeCredits } = payload;

    state.user.credits = credits;
    state.user.lastFreeCredits = lastFreeCredits;
    state.addDailyCreditsPending = false;
  });
  builder.addCase(addDailyCredits.rejected, (state) => {
    state.addDailyCreditsPending = false;
  });
};

export const setUsernameBuilder = (builder) => {
  builder.addCase(changeUsername.pending, (state) => {
    state.setUsernamePending = true;
  });
  builder.addCase(changeUsername.fulfilled, (state, { payload }) => {
    const { username, affiliateLink } = payload;
    state.user.username = username;
    state.user.affiliateLink = affiliateLink;
    state.setUsernamePending = false;
  });
  builder.addCase(changeUsername.rejected, (state) => {
    state.setUsernamePending = false;
  });
};

export const deleteAccountBuilder = (builder) => {
  builder.addCase(deleteAccount.pending, (state) => {
    state.deleteAccountPending = true;
  });
  builder.addCase(deleteAccount.fulfilled, (state) => {
    state.deleteAccountPending = false;
  });
  builder.addCase(deleteAccount.rejected, (state) => {
    state.deleteAccountPending = false;
  });
};

export const getReferralUsersBuilder = (builder) => {
  builder.addCase(getReferralUsers.pending, (state) => {
    state.getReferralUsersPending = true;
  });
  builder.addCase(getReferralUsers.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.referralEarnings.data = data;

    // state.referralEarnings.maxReached = maxReached;
    // state.referralEarnings.perPage = +perPage;
    // state.referralEarnings.page = +page;
    // state.referralEarnings.total = +total;
    state.getReferralUsersPending = false;
  });
  builder.addCase(getReferralUsers.rejected, (state) => {
    state.getReferralUsersPending = false;
  });
};

export const updateTrainModelBuilder = (builder) => {
  builder.addCase(updateTrainModel.fulfilled, (state, { payload }) => {
    const { credits } = payload.data;
    state.user.credits = credits;
    state.user.hasTrainedModel = true;
  });
};

export const toggleToFavoriteBuilder = (builder) => {
  builder.addCase(toggleToFavorite.pending, (state, { meta }) => {
    const { collectionId } = meta.arg;
    if (!state.user.favoriteCollections.includes(collectionId)) {
      state.user.favoriteCollections.push(collectionId);
    } else {
      state.user.favoriteCollections = state.user.favoriteCollections.filter(
        (c) => c !== collectionId
      );
    }
  });
  builder.addCase(toggleToFavorite.rejected, (state, { meta }) => {
    const { collectionId } = meta.arg;
    if (!state.user.favoriteCollections.includes(collectionId)) {
      state.user.favoriteCollections.push(collectionId);
    } else {
      state.user.favoriteCollections = state.user.favoriteCollections.filter(
        (c) => c !== collectionId
      );
    }
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.rejected, (state, action) => {
    state.user = undefined;
  });
};
